import { patchApi, postApi } from '../utils/api'

export function createContract({ data, options }) {
  return postApi({
    data,
    endpoint: 'api/contract/contracts/',
    options,
  })
}

export function updateContract({ data, id, options }) {
  return patchApi({
    data,
    endpoint: `api/contract/contracts/${id}/`,
    options,
  })
}
